export async function getJSON(path) {
    const response = await fetch(path);
    const body = await response.json();
    if (!response.ok) throw new Error(body.error || "Request failed");
    return body;
}

export const ytdQuery = "window=ytd";
